import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ArtikelLeverancier } from '../dto/artikel-leverancier';
import { CrudService, Filter } from '@mango/core';
import { Artikel } from '../dto/artikel';

@Injectable({ providedIn: 'root' })
export class ArtikelLeverancierService extends CrudService<ArtikelLeverancier> {

    constructor(injector: Injector) { super(ArtikelLeverancier, injector); }

    getArtikelFilter(artikelid: number): Filter<ArtikelLeverancier> {
        return new Filter<ArtikelLeverancier>(fb => [fb.equal("artikelID", artikelid)]);        
    }

    getArtikelLeverancierFilter(artikelid: number, leverancierid: number): Filter<ArtikelLeverancier> {
        return new Filter<ArtikelLeverancier>(fb => [fb.equal(x => x.artikelID.id, artikelid),fb.equal(x => x.leverancierID.id, leverancierid)] );
    }

}
